<template>
  <div>
    <EditPartner
      v-if="addPartnerModal"
      mode="add"
      :show="addPartnerModal"
      v-on:closeEditPartnerModal="addPartnerModal = false"
    />
    <ModalContainer :show="show" @close="onCancel">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        loader="bars"
      ></loading>

      <!-- Add Partner Modal -->
      <template slot="header">
        <h4 class="mb-0">{{ $t("add-partner") }}</h4>
      </template>

      <template slot="body">
        <form class="p-2" ref="PartnerDetailsRef">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="companyName">{{ $t("partner") }}</label>
                <select
                  v-model="partner"
                  name="partner"
                  class="form-control"
                  id="partner"
                  required
                >
                  <option value="">{{ $t("select-partner") }}</option>
                  <option
                    v-for="partner in partners"
                    :key="partner.id"
                    :value="partner.id"
                  >
                    {{ partner.name }}
                  </option>
                </select>
                <div class="font-12 gray4 mt-2">
                  Partner not listed?
                  <span class="text-primary cursor-pointer" @click="openAddPartner">
                    Add New Partner
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="btn-add">
            <button type="submit">{{ $t("add") }}</button>
          </div>
        </form>
      </template>

    </ModalContainer>
  </div>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import EditPartner from "./EditPartner.vue";

export default {
  name: "AddPartner",
  components: {
    ModalContainer,
    Loading,
    EditPartner,
  },
  props: {
    show: Boolean,
    onCancel: Function,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      partner: "",
      addPartnerModal: false,
    };
  },
  methods: {
    openAddPartner() {
      console.log("open add partner modal");
      // this.$emit("close-modal"); 

      this.addPartnerModal = true;
    },
  },
  computed: {
    // ...mapGetters(["partners"]),

    // partners() {
    //   return [
    //     { id: 1, name: "DHL" },
    //     { id: 2, name: "FedEx" },
    //     { id: 3, name: "GIG Logistics" },
    //   ];
    // },
  },
};
</script>

<style scoped>
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  background-color: rgba(33, 62, 122, 1);
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  font-size: 14px;
  font-weight: 600;
}
</style>
